import DownloadIcon from 'icons/Download.icon';
import {
  DATA_ROOM_SHAREABLE_LINK_REPORT_ACTION,
  DataRoomShareableLinkReportAction,
} from 'models/ShareableLink';
import EyeIcon from 'icons/Eye.icon';
import { IconProp } from 'models/Icon';

export const REPORT_ACTION_TRANSLATION = {
  [DATA_ROOM_SHAREABLE_LINK_REPORT_ACTION.DOWNLOAD]:
    'shareableReportDocumentDownloaded',
  [DATA_ROOM_SHAREABLE_LINK_REPORT_ACTION.VIEW]:
    'shareableReportDocumentViewed',
} as Record<DataRoomShareableLinkReportAction, string>;

export const REPORT_ACTION_ICONS = {
  [DATA_ROOM_SHAREABLE_LINK_REPORT_ACTION.DOWNLOAD]: DownloadIcon,
  [DATA_ROOM_SHAREABLE_LINK_REPORT_ACTION.VIEW]: EyeIcon,
} as Record<DataRoomShareableLinkReportAction, IconProp>;
